/* eslint-disable default-case */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionOutlined, SyncOutlined, CheckCircleOutlined, PlusCircleOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { ReactSVG } from 'react-svg';
import { Tooltip, message } from 'antd';
import { UserAtcuEnum } from '../enums/userAtcuEnum';
import { UserSpecialRoleEnum } from '../enums/userSpecialRoleEnum';
import confirmModal from '../../../core/components/modals/ConfirmModal';
import visitCardIcon from '../../../assets/images/icons/address-card-solid.svg';
import deleteIcon from '../../../assets/images/icons/icon_trash-can.svg';
import userPassGenerateIcon from '../../../assets/images/icons/user-lock.svg';
import userPermissionsIcon from '../../../assets/images/icons/user-shield-solid.svg';
import createdUser from '../../../assets/images/icons/user-gear-solid.svg';
import changeAtcu from '../../../assets/images/icons/plane-solid.svg';
import editIcon from '../../../assets/images/icons/penIcon.svg';
import setOjtiIcon from '../../../assets/images/icons/people-arrows-solid.svg';

const useUsersColumns = ({ pageKey, generatePassword, showDeleteUserModal, ojtiModalRef, addUserModalRef, userFormModalRef, showPermissionsModal, showData, changeAtcuModalRef, deleteUserModalRef, userAdministrationPermission, permissionsAdministrationPermission }) => {
  const { t } = useTranslation();
  const syncStatus = (record) => {
    switch (record) {
      case 'NOT_EDIT_USER': // EXIST_USER
        return (
        <Tooltip placement="right" title={t('users.notEditUser')}>
            <CheckCircleOutlined style={{ fontSize: '22px', color: 'green', paddingLeft: '30%', paddingTop: '5%', height: '30px', width: '45px' }} />
        </Tooltip>
        );
      case 'NEW_USER':
        return (
          <Tooltip placement="right" title={t('users.newUser')}>
            <PlusCircleOutlined style={{ fontSize: '22px', color: 'blue', paddingLeft: '30%', paddingTop: '5%', height: '30px', width: '45px' }} />
          </Tooltip>
        );
      case 'NOT_FOUND_USER':
        return (
          <Tooltip placement="right" title={t('users.notFoundUser')}>
            <CloseCircleOutlined style={{ fontSize: '22px', color: 'red', paddingLeft: '30%', paddingTop: '5%', height: '30px', width: '45px' }} />
          </Tooltip>
        );
      case 'EDIT_USER':
        return (
          <Tooltip placement="right" title={t('users.editUser')}>
            <ExclamationCircleOutlined style={{ fontSize: '22px', color: 'orange', paddingLeft: '30%', paddingTop: '5%', height: '30px', width: '45px' }} />
          </Tooltip>
        );
      case 'MANUALLY_CREATED_USER': // CREATED_USER
        return (
          <Tooltip placement="right" title={t('users.manuallyCreatedUser')}>
            <ReactSVG src={createdUser} style={{ color: 'gray', paddingLeft: '30%', marginBottom: '-5px', marginRight: '27px', height: '30px', width: '45px' }} />
          </Tooltip>
        );
    }
  }
  const columns = useMemo(
    () => [
      // {
      //   title: <>
      //     <SyncOutlined style={{ fontSize: '22px', color: '#393939', margin: '0px 0px 0px 5px' }} />
      //          </>,
      //   dataIndex: 'syncStatus',
      //   name: t('users.syncStatus'),
      //   key: 'status',
      //   sort: 'string',
      //   width: 30,
      //   columnVisible: true,
      //   render: (record) => syncStatus(record)
      // },
      {
        title: t('users.firstName'),
        dataIndex: 'firstName',
        key: 'firstName',
        type: 'string',
        filter: 'string',
        sort: 'string',
        width: 300,
        columnVisible: true
      },
      {
        title: t('users.fatherName'),
        dataIndex: 'fatherName',
        key: 'fatherName',
        type: 'string',
        filter: 'string',
        sort: 'string',
        width: 300,
        columnVisible: false
      },
      {
        title: t('users.lastName'),
        dataIndex: 'lastName',
        key: 'lastName',
        type: 'string',
        filter: 'string',
        sort: 'string',
        width: 300,
        columnVisible: true
      },
      // {
      //   title: t('users.JMB'),
      //   dataIndex: 'uniqueIdentificationNumber',
      //   key: 'uniqueIdentificationNumber',
      //   type: 'string',
      //   sort: 'string',
      //   filter: 'string',
      //   width: 300,
      //   columnVisible: false
      // },
      {
        title: t('users.email'),
        dataIndex: 'email',
        key: 'email',
        type: 'string',
        sort: 'string',
        filter: 'string',
        width: 450,
        columnVisible: true
      },
      {
        title: t('users.location'),
        dataIndex: 'scheduledAtcuIdentificator',
        key: 'scheduledAtcuIdentificator',
        type: 'string',
        filter: 'select',
        mode: 'multiple',
        sort: 'select',
        width: 300,
        columnVisible: true,
        render: (record) => {
          return (record);
        },
        filterOptions: Object.keys(UserAtcuEnum).map((type) => {
          return {
            id: type,
            key: type,
            value: type,
            title: t('user.' + type)
          };
        })
      },
      {
        title: t('users.role'),
        dataIndex: 'specialRole',
        key: 'specialRoles',
        type: 'string',
        sort: 'select',
        filter: 'select',
        mode: 'multiple',
        width: 200,
        columnVisible: true,
        render: (record) => t('users.' + record),
        filterOptions: Object.keys(UserSpecialRoleEnum).map((type) => {
          return {
            id: type,
            key: type,
            value: type,
            title: t('user.' + type)
          };
        })
      },
      {
        title: t('users.created'),
        dataIndex: 'created',
        key: 'created',
        type: 'dateRange',
        sort: 'dateRange',
        filter: 'dateRange',
        displayFormat: 'DD.MM.YYYY. HH:mm:ss',
        width: 300,
        columnVisible: true
      },
      {
        title: t('users.updated'),
        dataIndex: 'updated',
        key: 'updated',
        type: 'dateRange',
        sort: 'dateRange',
        filter: 'dateRange',
        displayFormat: 'DD.MM.YYYY. HH:mm:ss',
        width: 300,
        columnVisible: true
      },
      {
        dataIndex: 'action',
        key: 'action',
        width: 170,
        columnVisible: true,
        actionItems: [
          permissionsAdministrationPermission && {
            icon: userPermissionsIcon,
            onClick: (record) => {
              showPermissionsModal(record);
            },
            label: t('user.editPermissions'),
            tooltip: t('user.editPermissions')
          },
          permissionsAdministrationPermission && {
            icon: changeAtcu,
            onClick: (record) => {
              changeAtcuModalRef.current.showDialog(record);
            },
            label: t('buttons.changeAtcuAndRole'),
            tooltip: t('buttons.changeAtcuAndRole'),
          },
          userAdministrationPermission && {
            icon: editIcon,
            onClick: (record) => {
              addUserModalRef.current.showDialog(record);
            },
            label: t('users.editUserTitle'),
            tooltip: t('users.editUserTitle')
          },
          userAdministrationPermission && {
            icon: setOjtiIcon,
            onClick: (record) => {
              if (record?.specialRole !== 'STUDENT') {
                message.error('Samo je studentima moguće dodjeljivati OTJI-a.');
              } else ojtiModalRef.current.showDialog(record);
            },
            label: t('users.setOjti'),
            tooltip: t('users.setOjti')
          },
          {
            isHidden: true,
            onClick: (record) => {
              userFormModalRef.current.showDialog(
                showData(record)
              );
            },
            tooltip: t('buttons.visit'),
            label: t('buttons.visit'),
            icon: visitCardIcon,
          },
          userAdministrationPermission && {
            isHidden: true,
            onClick: (record) => {
              deleteUserModalRef.current.showDialog({
                ...record
              });
            },
            textProps: {
              title: t('users.delete'),
              content: t('users.deleteQuestion'),
            },
            tooltip: t('buttons.delete'),
            label: t('buttons.delete'),
            icon: deleteIcon,
          },
          userAdministrationPermission && {
            icon: userPassGenerateIcon,
            isHidden: true,
            onClick: (record) => {
              confirmModal({
                centered: true,
                icon: <QuestionOutlined />,
                title: t('users.generatePassword'),
                content: t('users.generateNewPasswordQuestion'),
                okText: t('buttons.yes'),
                cancelText: t('buttons.no'),
                onOk: () => generatePassword(record.id),
              });
            },
            label: t('user.generateNewPassword'),
            tooltip: t('buttons.generatePassword'),
          }
        ],
      },
    ],
    [t, pageKey]
  );

  return { columns };
};

export default useUsersColumns;
